import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ChangeDateConfirmationHeader from "./ChangeDateConfirmation/ChangeDateConfirmationHeader";
import ChangeDateConfirmationSecondaryHeader from "./ChangeDateConfirmation/ChangeDateConfirmationSecondaryHeader";
import ChangeDateConfirmationRequestProgress from "./ChangeDateConfirmation/ChangeDateConfirmationRequestProgress";
import ChangeDateConfirmationFlightDetails from "./ChangeDateConfirmation/ChangeDateConfirmationFlightDetails";
import ChangeDateConfirmationOrderIdContainer from "./ChangeDateConfirmation/ChangeDateConfirmationOrderIdContainer";
import ChangeDateConfirmationPriceBreakdown from "./ChangeDateConfirmation/ChangeDateConfirmationPriceBreakdown";
import ChangeDateConfirmationPassengers from "./ChangeDateConfirmation/ChangeDateConfirmationPassengers";
import ChangeDateConfirmationRemarks from "./ChangeDateConfirmation/ChangeDateConfirmationRemarks";
import TicketManagementConfirmationContact from "./Common/TicketManagementConfirmationContact";
import TicketManagementConfirmationFareRules from "./Common/TicketManagementConfirmationFareRules";
import ChangeDateConfirmationRemarksSection from "./ChangeDateConfirmation/ChangeDateConfirmationRemarksSection";
import ChangeDateConfirmationRelevantFiles from "./ChangeDateConfirmation/ChangeDateConfirmationRelevantFiles";

function TicketManagementFlightChangeDateConfirmationDetailsPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState();
  const [loading, setLoading] = useState();

  // useEffect(() => {
  //   if (data?.status) {
  //     if (data?.status !== "Success") {
  //       navigate(`/order/flight/ticket/changedate/confirmation/${id}`, {
  //         replace: true,
  //       });
  //     }
  //   }
  // }, [data?.status]);

  return (
    <div className="w-full flex flex-col items-center bg-background min-h-screen">
      <div className="flex flex-col w-full max-w-7xl items-center pb-10">
        <div
          className={`w-full flex flex-col items-center max-w-7xl gap-4 mt-4 px-3 lg:px-6 py-6 `}
        >
          <ChangeDateConfirmationHeader
            data={data}
            setData={setData}
            loading={loading}
            setLoading={setLoading}
          />
          {loading ? (
            <div className="w-full py-4 flex items-center justify-center">
              <div className="primaryLoader"></div>
            </div>
          ) : (
            <div className="flex flex-col w-full">
              <ChangeDateConfirmationSecondaryHeader data={data} />
              <ChangeDateConfirmationRequestProgress data={data} />
              <div className="flex w-full gap-4 lg:gap-6 flex-col lg:flex-row relative">
                <div className="flex flex-col flex-1">
                  <ChangeDateConfirmationOrderIdContainer data={data} />
                  <div className="w-full flex lg:hidden">
                    <ChangeDateConfirmationPriceBreakdown data={data} />
                  </div>
                  <ChangeDateConfirmationFlightDetails data={data} />
                  <TicketManagementConfirmationFareRules data={data} />
                  <ChangeDateConfirmationPassengers data={data} />
                  <ChangeDateConfirmationRelevantFiles data={data} />
                  <ChangeDateConfirmationRemarksSection data={data} />
                  <TicketManagementConfirmationContact />
                  <ChangeDateConfirmationRemarks />
                </div>
                <div className="lg:max-w-[350px] w-full hidden lg:flex">
                  <ChangeDateConfirmationPriceBreakdown data={data} />
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TicketManagementFlightChangeDateConfirmationDetailsPage;
